import {combineReducers} from '@modifi/redux'

import shipmentDetailsReducer from './shipment-details/reducer'
import shipmentsReducer from './shipments/reducer'
import userSettingsReducer from './user-settings/reducer'

export default combineReducers({
  shipmentDetails: shipmentDetailsReducer,
  shipments: shipmentsReducer,
  userSettings: userSettingsReducer,
})
